import React, { useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import Card from '@material-ui/core/Card';
import App from './App';
// import customTabsStyle from "./assets/jss/material-dashboard-react/components/customTabsStyle";
// import withStyles from "@material-ui/core/styles/withStyles";
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import MenuIcon from '@material-ui/icons/Menu';
import IconButton from '@material-ui/core/IconButton';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import Divider from "@material-ui/core/Divider";
import ComponentType from "./_Services/index";
import { actions } from "./reducers/app";
import { useDispatch, useSelector } from "react-redux";
// import { act } from '@testing-library/react';
import Signature from './Signature';
import axios from "axios";
import Qs from "qs";
import PF from "./_Services/publicFunction";
import MyBackdrop from './components/BackDrop/BackDrop';
import useSound from 'use-sound';
import switchlight from './sounds/switchlight.wav';
import Brightness2Icon from "@material-ui/icons/Brightness2";
import Brightness7Icon from "@material-ui/icons/Brightness7";
import { DarkModeSwitch } from 'react-toggle-dark-mode';
import { injectIntl, intlShape, useIntl, FormattedMessage } from 'react-intl';
import moment from "moment";
import { useGmailListItemStyles } from '@mui-treasury/styles/listItem/gmail';
import { indigo, teal, deepPurple } from '@material-ui/core/colors'

// import Backdrop from "@material-ui/core/Backdrop";

const domToImage = require('dom-to-image');

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    height: '100vh',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
    '@supports (height: 100dvh)': {
      height: '100dvh',
    },
  },
  appBar: {
    flexShrink: 0,
  },
  toolbar: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    [theme.breakpoints.down('sm')]: {
      flexWrap: 'wrap',
      minHeight: 'auto',
      padding: theme.spacing(0.75, 1),
    },
  },
  menuButton: {
    marginLeft: -24,
    [theme.breakpoints.down('sm')]: {
      marginLeft: 0,
      padding: 8,
    },
  },
  stepper: {
    padding: 0,
    width: 'auto',
    flex: '1 1 auto',
    minWidth: 0,
    [theme.breakpoints.down('sm')]: {
      order: 3,
      flexBasis: '100%',
      '& .MuiStepLabel-label': {
        fontSize: '0.72rem',
        lineHeight: 1.2,
      },
      '& .MuiStepConnector-line': {
        minHeight: 12,
      },
    },
  },
  backButton: {
    marginRight: theme.spacing(1),
    [theme.breakpoints.down('sm')]: {
      marginRight: 0,
    },
  },
  navActions: {
    marginLeft: theme.spacing(1),
    display: 'flex',
    gap: theme.spacing(1),
    flexShrink: 0,
    [theme.breakpoints.down('sm')]: {
      marginLeft: 'auto',
      '& .MuiButton-root': {
        minWidth: 64,
        padding: theme.spacing(0.75, 1),
        fontSize: '0.78rem',
        whiteSpace: 'nowrap',
      },
    },
  },
  instructions: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  contentCard: {
    flex: '1 1 auto',
    minHeight: 0,
    width: '100%',
    overflow: 'hidden',
    borderRadius: 0,
  },
  questionPane: {
    height: '100%',
    overflowY: 'auto',
    overflowX: 'hidden',
    boxSizing: 'border-box',
    paddingBottom: 'calc(96px + env(safe-area-inset-bottom))',
    WebkitOverflowScrolling: 'touch',
  },
  displayNone: {
    display: "none !important"
  },
}));


// const Questionaires = [66,67,68]


function getStepContent(stepIndex) {
  switch (stepIndex) {
    case 0:
      return '已經完成，是否修改';
    case 1:
      return 'What is an ad group anyways?';
    case 2:
      return 'This is the bit I really care about!';
    default:
      return 'Unknown stepIndex';
  }
}

function HorizontalLabelPositionBelowStepper(props) {
  const dispatch = useDispatch();
  const initialRender = React.useRef(true);
  const classes3 = useGmailListItemStyles({ color: teal[900] });

  const [MornjoyQuestionaires, setQuests] = React.useState({
    // 66: "勞檢問卷",
    // 67: "過勞評估量表",
    // 68: "心情量表",
  })

  const { tabList } = useSelector(state => ({
    tabList: state.app.tabList,
  }));

  const { questionaireList } = useSelector(state => ({
    questionaireList: state.app.questionaireList,
  }));
  const { UserInfo } = useSelector(state => ({
    UserInfo: state.app.UserInfo,
  }));
  const { dark } = useSelector(state => ({
    dark: state.app.dark,
  }));
  //初始
  React.useEffect(() => {
    const completeQ = ['66', '67', '68', '69', '70', '80']; //已設計問卷(有對應component)
    console.log(questionaireList);
    let obj = questionaireList.reduce((o, { SpecialItemNo, Title }) => {
      o[SpecialItemNo] = Title
      return o
    }, {})

    console.log(obj);
    setQuests(obj);
    let ary = Object.values(obj);
    Object.keys(obj).map((prop, key) => {
      let tab = {
        funcName: ary[key],
        componentName: prop  //作為KEY
      }
      dispatch(actions.TAB_ADD(tab));
    });
    //若有未設計到的component
    questionaireList.map(item => {
      if (!completeQ.includes(item.SpecialItemNo)) {
        dispatch(actions.TAB_EDIT({ editing: true, key: item.SpecialItemNo }))  //不須提交直接下一頁
      }
    })

    window.addEventListener("beforeunload", leaveApp);

    return () => window.removeEventListener("beforeunload", leaveApp)  //離開註銷
  }, []); //避免循環
  const intl = useIntl();

  const [imageURL, setImage] = React.useState(null);  //提交=>簽名檔img
  const [open, setOpen] = React.useState(false);
  const [backdrop, setBackdrop] = React.useState(false);
  const icon = !dark ? <Brightness7Icon /> : <Brightness2Icon />;
  const [playActive] = useSound(
    switchlight,
    { volume: 0.5 }
  );
  const [timestamp, setTime] = React.useState(null);

  const classes = useStyles();
  const [activeStep, setActiveStep] = React.useState(0);
  const steps = Object.values(MornjoyQuestionaires).reverse();

  const handleNext = (e, key) => {
    // setBackdrop(prevstate => (true));
    // console.log("NEXT")
    const finish = tabList[key].isEditing;
    //console.log(finish);
    if (!finish) {
      // alert("當前問卷尚未完成，請先提交當前問卷")
      alert(intl.formatMessage({ id: "app.QuestsNotYet" }))
    } else {
      setActiveStep((prevActiveStep) => prevActiveStep + 1);
    }

  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleReset = () => {
    const { history } = props

    // setActiveStep(0);
    setOpen(true)
    // setBackdrop(prevstate => (true));
    // setTimeout(() => {
    //   sessionStorage.removeItem('token');
    //   history.push("LOGIN")
    // }, 5000);

  };
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  const leaveApp = ev => {
    ev.preventDefault();
    return ev.returnValue = 'Are you sure you want to close?';
  }
  const handleLogOut = () => {
    const { history } = props
    setAnchorEl(null);
    setBackdrop(prevstate => (true));
    setTimeout(() => {
      sessionStorage.removeItem('token');
      history.push("LOGIN")
    }, 5400);

    // history.replace("", null); //清空紀錄
    // window.history.replaceState(null, null, "/");
    // dispat
  };
  const handleLogOutDirect = () => {
    const { history } = props
    setAnchorEl(null);
    sessionStorage.removeItem('token');
    history.push("LOGIN")

    // history.replace("", null); //清空紀錄
    // window.history.replaceState(null, null, "/");
    // dispat
  };
  React.useEffect(() => {
    if (initialRender.current) {
      initialRender.current = false;
    } else {

      var element = document.getElementById('signature');
      // var options = {
      //   filename:  sessionStorage.getItem('BarCodeStr')  + '.pdf',
      // };
      // var pdf = new jsPDF();

      domToImage.toBlob(element).then((blob) => {
        // var image = canvas.toDataURL("image/png");
        // pdf.addImage(image, 'JPEG', 0, 0);
        // document.body.appendChild(image)
        // var pdf2 = pdf.output('blob');
        let data = new FormData();
        data.append('files', blob, UserInfo.BarCodeStr + "-" + new Date().toISOString().split('T')[0] + '.png')
        PF.instance({
          method: "post",
          url: PF.url + "/Questionaire/Upload",
          data: data,
          headers: { token: sessionStorage.token }
        })
          .then(function (response) {
            // alert("完成")
            //console.log(response.data)
          })

      })
      handleLogOut();
    }
  }, [imageURL]); //避免循環
  useEffect(() => {
    if (!initialRender.current) {
      // console.log(activeStep)
      // console.log(steps.length)
      if (activeStep !== 0 && activeStep === steps.length) {
        setTimeout(() => {
          handleLogOut()
        }, 1000)
      }
    }

  }, [activeStep])
  const handleI18nChange = (event, lang) => {
    moment.locale(lang);
    dispatch(actions.LANG_SET(lang));
    setAnchorEl(null);
  };
  const { app } = useSelector(state => ({
    app: state.app,
  }));
  return (
    <>
      <div className={classes.root}>
        <AppBar className={classes.appBar} position="sticky" style={{ background: '#2E3B55' }}>
          <Toolbar className={classes.toolbar}>
            <IconButton
              edge="start"
              color="inherit" onClick={handleClick} className={classes.menuButton}
            >
              <MenuIcon />
            </IconButton>
            <Menu
              anchorEl={anchorEl}
              open={Boolean(anchorEl)}
              onClose={handleClose}
            >
              <MenuItem key="placeholder" style={{ display: "none" }} />
              <MenuItem>{UserInfo.UserName}</MenuItem>
              <MenuItem onClick={() => {
                dispatch(actions.THEME_SET({ theme: !dark }))
              }}
                onMouseDown={() => playActive()}
                style={{ display: "block", textAlign: "center", maxHeight: "36px" }}
              >
                <DarkModeSwitch
                  style={{ marginBottom: '2rem' }}
                  checked={dark}
                  onChange={f => f}
                  size={20} />
              </MenuItem>
              <MenuItem classes={classes3} style={{ color: app.i18n.locale === "zh-tw" ? "white" : "" }} selected={app.i18n.locale === "zh-tw"} value="zh-tw" onClick={(e) => handleI18nChange(e, "zh-tw")}>繁體中文</MenuItem>
              <MenuItem classes={classes3} style={{ color: app.i18n.locale === "en" ? "white" : "" }} selected={app.i18n.locale === "en"} value="en" onClick={(e) => handleI18nChange(e, "en")}>English</MenuItem>
              <Divider />
              <MenuItem onClick={handleLogOutDirect}><FormattedMessage id={"app.FillNextTime"} /></MenuItem>
            </Menu>
            <Stepper activeStep={activeStep} alternativeLabel className={classes.stepper}>
              {steps.map((label) => (
                <Step key={label}>
                  <StepLabel>{intl.formatMessage({ id: label })}</StepLabel>
                </Step>
              ))}
            </Stepper>
            <div className={classes.navActions}>
              {activeStep === steps.length ? (
                <div>
                  <Typography className={classes.instructions}><FormattedMessage id={"app.AllQuestsDone"} /></Typography>
                  {!imageURL ?
                    // (<Button onClick={handleReset} variant="contained" color="primary">簽名提交</Button>) :
                    (<Button onClick={handleLogOut} variant="contained" color="primary"><FormattedMessage id={"app.Logout"} /></Button>) : ""

                  }
                </div>
              ) : (
                <div>
                  {/* <Typography className={classes.instructions}>{getStepContent(activeStep)}</Typography> */}
                  <div>
                    <Button
                      disabled={activeStep === 0}
                      onClick={handleBack}
                      className={classes.backButton}
                      variant="contained"
                    >
                      <FormattedMessage id={"app.Back"} />
                    </Button>
                    <Button variant="contained" color="primary" onClick={(e) => handleNext(e, Object.keys(MornjoyQuestionaires).reverse()[activeStep])}>
                      {activeStep === steps.length ? <FormattedMessage id={"app.Done"} /> : <FormattedMessage id={"app.Next"} />}
                    </Button>
                  </div>
                </div>
              )}
            </div>
          </Toolbar>
        </AppBar>
        <Card
          className={classes.contentCard}
        >
          {Object.keys(MornjoyQuestionaires).reverse().map((prop, key) => {
            return (
              <div
                key={prop.key}
                className={activeStep === key ? classes.questionPane : classes.displayNone}
              >
                <ComponentType tag={prop} handleNext={handleNext} setActiveStep={setActiveStep} />
              </div>
            );
          })}
        </Card>
        {/* <Signature setImage={setImage} imageURL={imageURL} setTime={setTime} open={open} setOpen={setOpen} />
        {imageURL ?
          (<div id={"signature"} style={{ position: "absolute", paddingTop: "100px" }}>
            <div style={{ textAlign: "lefts" }} >
              <img
                src={imageURL}
                alt="my signature"
                align="center"
                style={{
                  // display: "block",
                  margin: "0 auto",
                  borderBottom: "1px solid black",
                  width: "250px",
                  paddingLeft: "30px", //讓簽名更像
                  paddingRight: "30px",//讓簽名更像
                }}
              />
            </div>
            <div>
              <label>簽名時間：{timestamp}</label>
            </div>
          </div>
          )
          : null
        } */}
        <MyBackdrop open={backdrop} />
      </div>
    </>
  );
}




export default HorizontalLabelPositionBelowStepper;
